import { create } from "zustand";

export type ThemeMode = "light" | "dark";

const THEME_STORAGE_KEY = "m-smart-entry-theme";

interface ThemeState {
	theme: ThemeMode;
	isDark: boolean;
}

interface ThemeActions {
	setTheme: (theme: ThemeMode) => void;
	toggleTheme: () => void;
	hydrate: () => void;
}

type ThemeStore = ThemeState & ThemeActions;

export const useThemeStore = create<ThemeStore>((set, get) => ({
	theme: "light",
	isDark: false,

	setTheme: (theme) => {
		localStorage.setItem(THEME_STORAGE_KEY, theme);
		set({
			theme,
			isDark: theme === "dark",
		});
	},

	toggleTheme: () => {
		const newTheme = get().theme === "light" ? "dark" : "light";
		localStorage.setItem(THEME_STORAGE_KEY, newTheme);
		set({
			theme: newTheme,
			isDark: newTheme === "dark",
		});
	},

	hydrate: () => {
		const stored = localStorage.getItem(THEME_STORAGE_KEY) as ThemeMode | null;
		if (stored && (stored === "light" || stored === "dark")) {
			set({
				theme: stored,
				isDark: stored === "dark",
			});
		}
	},
}));
